import { FC } from 'react'
import { SectionCaseStudyCardsProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { Container, Link, Media, SectionWrapper } from '@portfolio/components'

const StyledSectionWrapper = styled(SectionWrapper, {
  color: '$white',
  marginBottom: '$0',
})

const Content = styled('div', {
  margin: '0 auto',
  containerSpace: 'medium',
  display: 'grid',
  gap: '30px',
})

const Title = styled('h2', {
  projectFont: 'heading07',
})

const CardsList = styled('ul', {
  listStyleType: 'none',
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gridTemplateRows: 'repeat(3, 1fr)',
  gap: '30px',

  '@md': {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(1, 1fr)',
  },
})

const CaseStudyTitle = styled('h3', {
  color: '$white',
})

const CaseStudyDescription = styled('span', {
  color: '$white_07',
})

const CardsListItem = styled('li', {
  display: 'grid',
  position: 'relative',
  gridTemplateRows: 'auto auto',

  '@lg': {
    gridTemplateRows: '1fr 1fr',
  },
})

const MediaWrap = styled('div', {
  gridRow: 1,
  gridColumn: 1,
  overflow: 'hidden',
  borderRadius: '$r3',

  '& video + span': {
    clipPath: 'inset(1px round 24px)',
  },

  '@lg': {
    gridColumn: 1,
    gridRow: '1 / 3',
  },
})

const ContentWrap = styled(Container, {
  projectFont: 'heading08',

  display: 'grid',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  padding: '$24',
  zIndex: '$content',
  alignContent: 'flex-end',
  justifyContent: 'space-between',
  background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))',
  borderRadius: '$r3',
})

const LinkWrap = styled(Link, {
  gridColumn: 1,
  gridRow: '1 / -1',
  zIndex: '$content',
  '&:focus-visible': {
    outline: '$focusBlue solid 5px;',
    outlineOffset: '-5px',
  },
})
export const SectionCaseStudyCards: FC<SectionCaseStudyCardsProps> = ({
  title,
  cards,
}) => {
  if (!cards?.length) return null

  return (
    <StyledSectionWrapper type="NO_MARGIN">
      <Content>
        {title && <Title>{title}</Title>}

        <CardsList>
          {cards.map(({ _key, media, caseStudyReference }) =>
            media?.mediaPayload ? (
              <CardsListItem key={_key}>
                <MediaWrap>
                  <Media
                    {...media}
                    layout="responsive"
                    controlsPosition="top-right"
                    hardcropRatio="portrait3"
                    loop
                  />
                </MediaWrap>

                <ContentWrap>
                  {caseStudyReference?.name && (
                    <CaseStudyTitle as={title ? 'h3' : 'h2'}>
                      {caseStudyReference?.name}

                      {caseStudyReference?.shortDescription && (
                        <CaseStudyDescription>
                          {' '}
                          {caseStudyReference?.shortDescription}
                        </CaseStudyDescription>
                      )}
                    </CaseStudyTitle>
                  )}
                </ContentWrap>

                {caseStudyReference?.path && (
                  <LinkWrap
                    href={caseStudyReference?.path}
                    appearance="grid"
                    label={`Case Study - ${caseStudyReference?.name}`}
                  />
                )}
              </CardsListItem>
            ) : null,
          )}
        </CardsList>
      </Content>
    </StyledSectionWrapper>
  )
}
